module.exports = __webpack_public_path__ + "img/image8.127a442d.png";